import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';
import imagesReducer from 'web-app/react/feed/post/post-images/reducer';

const initialImageGalleryState = () => ({
    images: [],
    options: {},
    context: undefined,
    showUntagWarning: false,
    isTaggingImage: false,
    isLikingImage: false,
    childrenToTagShown: false,
    currentImageIndex: undefined,
    feedItemId: undefined,
    childrenIds: undefined,
    siteId: undefined,
    showShareAction: false,
    allowedChildrenToTag: undefined,
});

const imageAction = (state, action) => ({
    ...state,
    images: imagesReducer(state.images, action),
    isTaggingImage: false,
    isLikingImage: false,
});

const startLikingImage = state => {
    return {
        ...state,
        isLikingImage: true,
    };
};
const endLikingImage = state => {
    return {
        ...state,
        isLikingImage: false,
    };
};

const startTaggingImage = state => {
    return {
        ...state,
        isTaggingImage: true,
    };
};
const endTaggingImage = state => {
    return {
        ...state,
        isTaggingImage: false,
    };
};

const imageGalleryReducer = handleActions(
    {
        [actionTypes.SHOW_IMAGE_GALLERY]: (state, {payload}) => {
            return {
                ...state,
                context: payload.context,
                images: payload.images,
                options: payload.options,
                showUntagWarning: payload.showUntagWarning,
                currentImageIndex: payload.options.index,
                showShareAction: payload.showShareAction,
                feedItemId: payload.feedItemId,
                siteId: payload.siteId,
                childrenIds: payload.childrenIds,
            };
        },
        [actionTypes.CLOSE_IMAGE_GALLERY]: state => {
            return {
                ...state,
                images: [],
                options: null,
            };
        },
        [actionTypes.CLOSE_IMAGE_GALLERY_SUCCESS]: state => {
            return {
                ...state,
                showShareAction: false,
                context: undefined,
                feedItemId: undefined,
                siteId: undefined,
                childrenIds: undefined,
            };
        },
        [actionTypes.SET_CURRENT_IMAGE_INDEX]: (state, action) => {
            return {
                ...state,
                currentImageIndex: action.payload,
            };
        },
        [actionTypes.SHOW_CHILDREN_TO_TAG]: (state, action) => {
            return {
                ...state,
                childrenToTagShown: action.payload,
            };
        },
        [actionTypes.LIKE_IMAGE]: startLikingImage,
        [actionTypes.UNLIKE_IMAGE]: startLikingImage,
        [actionTypes.TAG_IMAGE]: startTaggingImage,
        [actionTypes.REMOVE_IMAGE_TAG]: startTaggingImage,
        [actionTypes.LIKE_IMAGE_FAILED]: endLikingImage,
        [actionTypes.UNLIKE_IMAGE_FAILED]: endLikingImage,
        [actionTypes.TAG_IMAGE_FAILED]: endTaggingImage,
        [actionTypes.REMOVE_IMAGE_TAG_FAILED]: endTaggingImage,
        [actionTypes.LIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.UNLIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.TAG_IMAGE_SUCCESS]: imageAction,
        [actionTypes.REMOVE_IMAGE_TAG_SUCCESS]: imageAction,
    },
    initialImageGalleryState(),
);

export default imageGalleryReducer;
